import { createReducer, on } from '@ngrx/store';

import { FilesActions } from '../actions/files.actions';

import { AuthActions } from '../actions/auth.actions';

import { FilesStoreUtils } from '../store-utils/files-store.utils';
import { FileData } from 'src/app/public/common/models/file-data.model';

//import { CarActions } from './app.actions';


export interface FilesState {
    carImagesFolders: Map<string, Array<FileData>>;
    carImageSamples: Map<string, Blob>;

    carDocumentsFolders: Map<string, Array<FileData>>;

    currentFileData: FileData;

    fetchingPreview: boolean;
    fetchingResults: boolean;
}

export const initialFilesData: FilesState = {
    carImagesFolders: new Map([]),  
    carImageSamples: new Map([]), 
    
    carDocumentsFolders: new Map([]), 

    currentFileData: new FileData("", new Blob()),

    fetchingPreview: false,
    fetchingResults: false
};

export const filesReducer = createReducer(
    initialFilesData,
   
    on( FilesActions.uploadCarImageSuccess, (state, action) => {
        
        return {
            ...state
            //carImageFolders: StoreUtils.addImageToCarImageFolder(state.carImageFolders, action.carId, action.blob)
            //carImageFolders: [...state.carImageFolders, new ImageFolder(action.carId, action.blob)]
            //carImagesFolders: StoreUtils.addImageToCarImagesFolders(state.carImagesFolders, action.carId, action.blob)
        };
        
    }),

    on( FilesActions.convertDocumentSuccess, (state, action) => {
        
        return {
            ...state,
            currentFileData: new FileData(action.carDocumentType.toString(), action.file, action.content)
        };
        
    }),

    on( FilesActions.uploadCarDocumentSuccess, (state, action) => {
        
        return {
            ...state,
            //carImageFolders: StoreUtils.addImageToCarImageFolder(state.carImageFolders, action.carId, action.blob)
            //carImageFolders: [...state.carImageFolders, new ImageFolder(action.carId, action.blob)]
            //carImagesFolders: StoreUtils.addImageToCarImagesFolders(state.carImagesFolders, action.carId, action.blob)
        };
        
    }),

    on( FilesActions.fetchCarImageSuccess, (state, action) => {
        
        return {
            ...state, 
            //carImageFolders: StoreUtils.addImageToCarImageFolder(state.carImageFolders, action.carId, action.blob)
            //carImageFolders: [...state.carImageFolders, new ImageFolder(action.carId, action.blob)]
            carImagesFolders: FilesStoreUtils.addImageToCarImagesFolders(state.carImagesFolders, action.carId, action.imageDatas)
        };
        
    }),

    on( FilesActions.fetchCarDocumentSuccess, (state, action) => {
        
        return {
            ...state, 
            //carImageFolders: StoreUtils.addImageToCarImageFolder(state.carImageFolders, action.carId, action.blob)
            //carImageFolders: [...state.carImageFolders, new ImageFolder(action.carId, action.blob)]
            carImagesFolders: FilesStoreUtils.addDocumentToCarDocumentsFolders(state.carDocumentsFolders, action.carId, action.documentDatas)
        };
        
    }),

    on( FilesActions.fetchCarImageSampleSuccess, (state, action) => {
        
        return {
            ...state, 
            //carImageFolders: StoreUtils.addImageToCarImageFolder(state.carImageFolders, action.carId, action.blob)
            //carImageFolders: [...state.carImageFolders, new ImageFolder(action.carId, action.blob)]
            carImageSamples: FilesStoreUtils.addImageToCarImageSamples(state.carImageSamples, action.filename, action.blob)
        };
        
    }),

    on( AuthActions.logoutSubmit, (state) => {
        //localStorage.removeItem("token");
        return {
            ...state,
            carImagesFolders: new Map(),
            carImageSamples: new Map(),

            carDocumentsFolders: new Map(),
        };
    })

);

// selectors

export const selectFilesFetchingPreview = (state: FilesState) => state.fetchingPreview;
export const selectFilesFetchingResults = (state: FilesState) => state.fetchingResults;



    